import { FieldInfoMessage, ToggleInputSM } from '@apps-common/components/elements'
import { VertSpacerMd } from '@apps-common/components/layout'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ThemeSelector } from '@apps-common/components/theme'
import { ModalDismiss } from '@apps-common/config/modal'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { useMyMonitoringNotificationsStore, useThemeStore } from '@apps-common/stores'

interface IProps {
  // open: boolean
  // close: () => void
  //   site?: IMMSiteModel
}

export const SettingsModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IProps
}) => {
  const { hydrated, notificationsEnabled, setNotificationsEnabled } = useMyMonitoringNotificationsStore()
  const { editing, toggleEditing } = useThemeStore()

  const updating = false

  return (
    <ModalContainer innerClasses='!h-auto !min-h-0' onDismiss={onDismiss}>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader title='Settings' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} ignoreCtxTheme />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[90px] !pb-[10px]'>
        <div className='flex flex-col gap-6'>
          <div>
            <ToggleInputSM
              labelLeft='Notifications'
              containerClassName='!mb-0 !px-0'
              innerContainerClassName='!m-0 !px-0'
              loading={!hydrated}
              disabled={updating}
              registration={{
                checked: notificationsEnabled,
                onChange: (e: any) => {
                  if (e?.target?.checked !== undefined) {
                    setNotificationsEnabled(e?.target?.checked)
                  }
                }
              }}
              ignoreCtxTheme
            />
            <FieldInfoMessage message='Global notification settings for this device. Disabling . Site-specific notification settings can be configured under Site Settings.' />
          </div>
          <div>
            <div className='flex items-center justify-between'>
              <div className='pl-[10px] text-[0.9em] sm:text-[1em] text-text mr-[10px]'>Theme mode</div>
              <ThemeSelector />
            </div>
            <FieldInfoMessage message='App theme mode. Configure to follow the system setting, or always use light or dark mode.' />
          </div>
          <Authorization
            roles={AUTH_CLAIMS.myMonitoringManagementAdmin.roles}
            scopes={AUTH_CLAIMS.myMonitoringManagementAdmin.scopes}
            ignoreDev
          >
            <>
              <ToggleInputSM
                labelLeft='Theme editor'
                containerClassName='!mb-0'
                innerContainerClassName='!m-0 !px-0'
                disabled={false}
                registration={{
                  checked: editing,
                  onChange: (e: any) => toggleEditing()
                }}
                ignoreCtxTheme
              />
            </>
          </Authorization>
          <VertSpacerMd />
        </div>
      </ModalBody>
    </ModalContainer>
  )
}
